<template>
    <div class="basket">
        <div :class="{ 'basket--mobile-hidden': !showMobile }">
            <h4>{{ myResources.title }}</h4>
            <div class="basket__loading" v-if="!serviceBasket">
                <i class="fas fa-cog fa-spin" />
            </div>
            <div v-else-if="serviceBasket.hasItems">
                <ul class="basket__items">
                    <li v-for="item in serviceBasket.items"
                        :key="item.serviceTypeId"
                        class="basket__item">
                        <span class="basket__item__title">{{ item.name }}</span>
                        <span><span class="basket__item__delete" @click="$emit('delete', item)"><span class="far fa-trash-alt" /></span></span>
                        <span v-if="!$scheme.priceless">{{ item.costDisplay }}</span>
                    </li>
                </ul>
                <div class="basket__summary" v-if="serviceBasket.totalCost && !$scheme.priceless">
                    <h4>{{ myResources.costTitle }}</h4>
                    <span class="basket__cost">
                        {{ serviceBasket.totalCostDisplay }}</span>
                </div>
            </div>
            <p v-else class="basket__empty">
                {{ myResources.emptyBasketText }}
            </p>
        </div>
        <div class="basket__actions" v-if="!hideContinue">
            <hh-btn class="basket__actions--view-basket --mobile-only"
                    type="cancel"
                    :text="myResources.viewBasket"
                    :disabled="!canViewBasket"
                    @click="onViewBasket" />
            <hh-btn :text="commonResources.continue" @click="onProceed" track-operation-state />
        </div>
        <p class="basket--mobile-hidden" v-if="!hideContinue">
            {{ myResources.summary }}
        </p>
    </div>
</template>

<script>

import ProgressManager from '@/progress-manager'
import ResourcesHelper from '@/components/resources-helper'
import ServiceBasket from '@/models/service-basket'

export default {
    mixins: [
        ResourcesHelper,
    ],

    props: {
        serviceBasket: {
            type: ServiceBasket,
            default: null,
        },
        hideContinue: {
            type: Boolean,
            default: false,
        },
        showMobile: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        /**
         * @returns {ServiceBasketBasketResources}
         */
        myResources() {
            return this.parseResources('components.serviceBasket.basket')
        },

        /**
         * Return true if the basket has items in and can be viewed.
         * @returns {boolean}
         */
        canViewBasket() {
            return this.serviceBasket && this.serviceBasket.hasItems
        },
    },

    methods: {
        /**
         * Proceed to the next screen.
         */
        onProceed() {
            ProgressManager.markVisitedRoute(this.$router.currentRoute.name)
            this.$router.push(ProgressManager.getNext(this.$route.name))
        },

        /**
         * Go to the basket summary.
         */
        onViewBasket() {
            this.$router.push({ name: 'BasketSummary' })
        },
    },
}

</script>

<style lang="scss">

.basket {
    h4 {
        margin-bottom: 0.5rem;
    }

    span {
        text-align: right;
    }

    @include modifier('mobile-hidden') {
        display: none;

        @include bp-min-mid {
            display: block;
        }
    }

    @include element('loading') {
        font-size: 1.5rem;
        text-align: center;
    }

    @include element('items') {
        margin: 0;
        padding: 0;
    }

    @include element('item') {
        display: grid;
        grid-template-columns: auto 4rem 4rem;
        padding: 0 0 $base-gutter 0;

        .basket__item__title {
            text-align: left;
        }

        @include element('delete') {
            cursor: pointer;
            padding: 0.1rem;
        }
    }

    @include element('summary') {
        display: grid;
        grid-template-columns: 4fr 1fr;
        margin: $wide-gutter 0;
    }

    @include element('actions') {
        position: fixed;
        left: 0;
        right: 0;
        bottom: $footer-height-base;
        padding: $base-gutter;

        @include bp-min-mid {
            position: static;
            padding-left: 0;
            padding-right: 0;
        }

        .button {
            width: 100%;
            margin-top: 10px;
        }
    }
}

</style>
